<template>
  <div class="main-table">
      <p class="tableTitle">题目详情: <span class="addItem" @click.stop='addNewTable()'></span></p>
      <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        fixed
        label="序列号"
        width="70"
        type="index"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="subject"
        label="题目(限50字符以内)"
        width="420">
      </el-table-column>
      <el-table-column
        prop="soptions"
        label="选项"
        >
      </el-table-column>
      <el-table-column
        prop="rightResult"
        label="答案"
        width='100'
      >
      </el-table-column>
      <el-table-column
        label="操作"
        width="140">
        <template slot-scope="scope">
          <el-button @click.stop="showDetail(scope.$index, scope.row, scope.store)" v-if='scope.row.subject.length > 0' type="text" size="small">查看</el-button>
          <el-button @click.stop="seeOredit(scope.$index, scope.row, scope.store)" type="text" size="small">修改</el-button>
          <el-button @click.stop="deleteOne(scope.$index, scope.row, scope.store)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <edit-table ref='editTableRef'></edit-table>
    <detail-table ref='detailTableRef'
                  v-if='showDetailTable'
                  @cancleD='cancleChangeDetail()'
                  :index='iIndex'>
    </detail-table>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import EditTable from '@/components/EditTable'
import DetailTable from '@/components/DetailTable'
export default {
  name: 'MainTable',
  components: {
    EditTable,
    DetailTable
  },
  data() {
      return {
        showDetailTable: false,
        ofrom: 'onew',
        iIndex: 0,
        selectTableinfo: ''
      }
    },
    computed: {
      ...mapGetters({
        'tableData': 'getAllTableInfo',
        'ableAdd': 'getTablesLength'
      })
    },
    methods: {
      ...mapMutations({
        'deleteOneTable': 'clearSingleTableInfo'
      }),
      deleteOne(oIndex, row, store) {
        this.deleteOneTable(this.tableData[oIndex]);
      },
      addNewTable() {
        if (this.ableAdd < 5) {
          this.$refs.editTableRef.show('new', '');
        } else {
          this.$message({
            message: '可添加题目数量不应超过5题！！！',
            type: 'warning'
          });
        }
      },
      seeOredit(oIndex, row, store) {
        this.$refs.editTableRef.show('modify', oIndex);
      },
      showDetail(oIndex, row, store) {
        this.showDetailTable = true;
        this.iIndex = oIndex;
      },
      indexMethod(index) {
        return index + 1;
      },
      cancleChangeDetail() {
        this.showDetailTable = false;
      }
    },
    mounted() {
      // console.log('===', this.tableData);
    }
}
</script>

<style lang="scss" scoped>
@import "~@/common/mixin.scss";

.main-table {
  width: 100%;
  .tableTitle {
    padding: 20px 0px 20px 0px;
    position: relative;
    .addItem {
      display: inline-block;
      position: absolute;
      right: 6px;
      width: 26px;
      height: 26px;
      background:url('./images/add.svg') no-repeat center center;
      background-size: 100% 100%;
      border-radius: 50%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MainTable.vue